module.exports = __webpack_public_path__ + "static/media/pointer.cc63c987.svg";